import React from 'react';

const getNonEmpty = (value: unknown, fallback = '-') => {
  if (value === null || value === undefined) return fallback;
  const text = String(value).trim();
  return text.length ? text : fallback;
};

export const CustomFieldValue: React.FC<{ value: unknown }> = ({ value }) => {
  if (Array.isArray(value)) {
    if (!value.length)
      return (
        <div className="company-details-screen__empty font-regular">-</div>
      );
    return (
      <div className="company-details-screen__chip-wrap company-details-screen__chip-wrap--inline">
        {value.map((item, idx) => (
          <span
            className="company-details-screen__chip font-regular"
            key={`${String(item)}-${idx}`}
          >
            {String(item)}
          </span>
        ))}
      </div>
    );
  }

  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>);
    if (!entries.length)
      return (
        <div className="company-details-screen__empty font-regular">-</div>
      );
    return (
      <div className="company-details-screen__option-wrap">
        {entries.map(([option, selected]) => (
          <label className="company-details-screen__option" key={option}>
            <input type="checkbox" checked={Boolean(selected)} readOnly />
            <span>{option}</span>
          </label>
        ))}
      </div>
    );
  }

  return (
    <div className="company-details-screen__value font-semibold">
      {getNonEmpty(value)}
    </div>
  );
};
